export enum DateRange {
  THIS_YEAR = 'THIS_YEAR',
  LAST_WEEK = 'LAST_WEEK',
  LAST_2_MONTH = 'LAST_2_MONTH',
  LAST_YEAR = 'LAST_YEAR',
}

export interface DateRangeProperty {
  dateRange?: DateRange;
  to?: string;
  from?: string;
  toDate?: string;
  fromDate?: string;
}
